import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UnitInfo } from '@cue/navigation-services';
import { NgTemplateOutlet } from '@angular/common';
import { ExpansionPanelComponent } from '@progress/kendo-angular-layout';
import { UnitDetailComponent } from '@cue/navigation-widgets';

@Component({
  selector: 'assist-multiview-renew-device',
  imports: [NgTemplateOutlet, ExpansionPanelComponent, UnitDetailComponent],
  templateUrl: './multiview-renew-device.component.html',
  styleUrl: './multiview-renew-device.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiviewRenewDeviceComponent {
  unitInfos = input.required<UnitInfo[]>();
  loading = input.required<boolean>();
}
